import Dexie, { Table } from "dexie";
import { FilterItem, DisplayItem } from "models/CorpScreening";

const DATABASE_NAME = "valuesearch-db";
const DATABASE_VERSION = 1;

type ScreeningTreeRecord = {
  id: "filterTree" | "displayTree";
  data: FilterItem[] | DisplayItem[];
};

class ScreeningTreeDB extends Dexie {
  screeningTree!: Table<ScreeningTreeRecord, string>;

  constructor() {
    super(DATABASE_NAME);
    this.version(DATABASE_VERSION).stores({
      screeningTree: "id"
    });
  }
}

export const db = new ScreeningTreeDB();

// IndexedDBに絞り込みツリーを保存する
export const saveFilterTreeToDB = async (filterTree: FilterItem[]) => {
  try {
    await db.screeningTree.put({ id: "filterTree", data: filterTree });
  } catch (error) {
    console.error("Failed to save filter tree to IndexedDB:", error);
    throw error;
  }
};

// IndexedDBに表示項目ツリーを保存する
export const saveDisplayTreeToDB = async (displayTree: DisplayItem[]) => {
  try {
    await db.screeningTree.put({ id: "displayTree", data: displayTree });
  } catch (error) {
    console.error("Failed to save display tree to IndexedDB:", error);
    throw error;
  }
};

// IndexedDBの絞り込みツリーをクリアする
export const clearScreeningTreeFromDB = async () => {
  try {
    await db.screeningTree.clear();
  } catch (error) {
    console.error("Failed to clear screening tree from IndexedDB:", error);
    throw error;
  }
};
